/**
 * Startdatei-Auswahl ("Eigene Startdatei").
 *
 * Modloader-Installer (forge-<ver>-installer.jar, neoforge-*-installer.jar,
 * fabric-installer-*.jar) liegen nach der Installation noch im Server-Ordner,
 * starten aber KEINEN Server: ohne --installServer oeffnen sie ein Installations-
 * Fenster und beenden sich auf dem Server sofort wieder. Wird so eine Jar als
 * Startdatei gewaehlt, ist der Server 2 Sekunden nach dem Start wieder offline.
 * Deshalb stehen sie gar nicht erst zur Auswahl (das Backend lehnt sie zusaetzlich
 * beim Speichern ab — siehe backend/server/services/launch-file.js).
 */
const INSTALLER_JAR = /installer[^/\\]*\.jar$/i;

export function isInstallerJar(fileName: string): boolean {
    return INSTALLER_JAR.test((fileName || '').trim());
}

/** Entfernt Dateien aus der Auswahl, die nachweislich keinen Server starten. */
export function selectableLaunchFiles(names: string[]): string[] {
    return names.filter((n) => !isInstallerJar(n));
}
